import moment from 'moment';

/* OJO::::
    EL PROYECTO NO TIENE AMBIENTE QA, solo en el back(java) se puede cambiar el tipo de ambiente desde application.properties
*/
//produccioN EXTERNA PUBLICA
export const API_BASE = 'https://chapur63.chapur.com/PortalProveedores/';
//EndPoint Produccion INTERNA
//export const API_BASE = 'http://10.2.91.55:8080/PortalProveedores/';
//Red Local
//export const API_BASE = 'http://10.3.1.156:8080/';
//Local
//export const API_BASE = 'http://localhost:8080/';
export const VERSION_APP = 'Versión: 1.1.0.2';
export const SYSTEM = 'PortalProveedores';
export const LOGIN= 1;
export const LOGOUT = 0;
export const defaultDates = {
    'fechaIni': moment(new Date()).startOf('week'),
    'fechaFin': moment(new Date())
};
export const SUPER_ADMIN = 'SUPER_ADMIN';
export const ADMIN_PROVEEDOR = 'ADMIN_PROVEEDOR';

export const requests = {
    token: 'oauth/token',
    userData: 'oauth/login',
    basicInfoProveedor: 'proveedores/vendor',
    changeVendor: 'proveedores/changeVendorData/',
    vendorCompanyNames: API_BASE + 'open/proveedor/',
    registro: API_BASE + 'open/registro',
    resetPassword: API_BASE + 'open/reset-password',
    cahngePassword: API_BASE + 'open/change-password',
    validaProveedor: API_BASE + 'open/valida-uuid-proveedor',
    obtenerProveedores: API_BASE + 'open/proveedor/',
    obtenerRoles: API_BASE + 'open/obtener-roles/',
    logInOut: API_BASE + 'open/logInOut',
    ordenesCompra: {
        listado: 'ordenes-compra',
        detalle: 'ordenes-compra/detalle',
        descarga: 'ordenes-compra/descargar'
    },
    facturas: {
        listado: 'facturas',
        detalle: 'facturas/detalle',
        descarga: 'facturas/descargar',
        creditos: 'facturas/credito-factura',
        creditoFactura: 'facturas/credito-factura/detalle'
    },
    pagos: {
        listado: 'pagos',
        detalle: 'pagos/detalle',
        descarga: 'pagos/descargar',
        anticipos: 'pagos/anticipos',
        anticiposDescarga: 'pagos/anticipos/descargar'
    },
    bonificaciones: {
        listado: 'bonificaciones',
        detalle: 'bonificaciones/detalle',
        descarga: 'bonificaciones/descargar',
        devoluciones: 'bonificaciones/devoluciones'
    },
    notasCredito: {
        listado: 'notas',
        detalle: 'notas/detalle',
        descarga: 'notas/descargar'
    },
    inventarios: {
        listado: 'inventory/listado',
        detalle: 'inventory/detalle',
        descarga: 'inventory/descargar'
    },
    ventas: {
        reporte: 'ventas/reporte',
        descarga: 'ventas/descargar',
        reporteGeneral: 'ventas/reporte-general',
        reporteClase: 'ventas/reporte-clase',
        reporteDepto: 'ventas/reporte-departamento'
    },
    usuarios: {
        listado: 'usuarios',
        actualizar: 'usuarios/actualizar'
    },
    catalogos: {
        obtenerRoles: 'oauth/obtener-roles'
    }
};
